import { Link } from "react-router";

import estilos from "./Layout.module.css";

/** The Prisma mark: a prism splitting one claim into the official and the cited reading. */
export function Marca(props: { onClick?: () => void }) {
  return (
    <Link to="/" className={estilos.marca} onClick={props.onClick}>
      <svg width="26" height="26" viewBox="0 0 32 32" aria-hidden="true">
        <path
          d="M16 3 29 27H3Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <path d="M16 12 21 27" stroke="var(--oficial)" strokeWidth="2.5" />
        <path d="M16 12 11 27" stroke="var(--citado)" strokeWidth="2.5" />
      </svg>
      Prisma
    </Link>
  );
}
